import classNames from 'classnames'
import { useEffect, useState } from 'react'
import styles from './index.module.scss'

interface Props {
  placeholder: string
  buttonText: string
  width?: string
  value?: string
  onSearch: (keyword: string) => void
}

export default function Search({ placeholder, value, width = '100%', buttonText, onSearch }: Props) {
  const [inputValue, setInputValue] = useState(value || '')

  useEffect(() => {
    setInputValue(value || '')
  }, [value])
  const handleInput = (e: any) => {
    setInputValue(e.target.value)
  }
  const handleKeyDown = (e: { keyCode: number }) => {
    if (e.keyCode === 13) {
      // 回车
      onSearch(inputValue)
    }
  }
  return (
    <div className={classNames(styles['yq-search-container'])} style={{ maxWidth: width }}>
      <div className={styles.formGroup}>
        <div className={classNames(styles['input-search'], 'input-group input-group-lg')}>
          <input
            id="yq-search-input"
            type="text"
            className="form-control"
            placeholder={placeholder}
            onInput={handleInput}
            value={inputValue}
            onKeyDown={handleKeyDown}
          />
          {/* <button
            id="yq-search-clear"
            type="button"
            aria-label="Close"
            // onClick={handleCarriersInput}
            className={classNames(
              'input-search-close',
              'btn-close',
              styles['fa-clear'],
              'font-size-20',
              !inputValue ? 'hide' : ''
            )}
          ></button> */}
        </div>
        <button className={styles.searchButton} onClick={onSearch.bind(null, inputValue)}>
          {/* <i className={classNames('input-search-icon', 'fa-search')}></i> */}
          <span>{buttonText}</span>
        </button>
      </div>
    </div>
  )
}
